<fengstui-global-loading></fengstui-global-loading>
<div
  class="app"
  [ngClass]="{
    'app--logged': (isAuth | async),
    'app--otherpages': (!(isHome | async) && !(isAuth | async)),
    'app--dependent': (isDependent | async),
    'app--staging': !fengEnv?.production && !fengEnv?.maintenance && fengSettings?.auth?.staging?.enable && (isAuthStaging | async),
    'app--resale': (isResale | async),
    'app--loading': (isLoading | async)
  }"
>

  <fengstlayout-staging-bar
    *ngIf="!fengEnv?.production && !fengEnv?.maintenance && fengSettings?.auth?.staging?.enable && (isAuthStaging | async)"
  ></fengstlayout-staging-bar>

  <fengstlayout-resale-bar
    *ngIf="!fengEnv?.maintenance && !fengSettings?.auth?.staging?.enable || (fengSettings?.auth?.staging?.enable && (isAuthStaging | async))"
  ></fengstlayout-resale-bar>

  <fengstlayout-header
    [isAuth]="(isAuth | async)"
    [isHome]="(isHome | async)"
    [isDependent]="(isDependent | async)"
    [isResale]="(isResale | async)"
    *ngIf="!fengEnv?.maintenance && (fengEnv?.production || (!fengSettings?.auth?.staging?.enable || (fengSettings?.auth?.staging?.enable && (isAuthStaging | async))))"
  ></fengstlayout-header>

  <div class="fengst-nav">
    <fengstlayout-modal-cookies-info *ngIf="this.fengSettings?.name === 'stvasco'"></fengstlayout-modal-cookies-info>
    <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
  </div>

  <fengstlayout-footer
    [isAuth]="(isAuth | async)"
    [isHome]="(isHome | async)"
    [isDependent]="(isDependent | async)"
    [isResale]="(isResale | async)"
    *ngIf="!fengEnv?.maintenance && (fengEnv?.production || (!fengSettings?.auth?.staging?.enable || (fengSettings?.auth?.staging?.enable && (isAuthStaging | async))))"
  ></fengstlayout-footer>

  <div class="fengstapp__whatsapp">
    <a href="https://wa.me/552139552011" target="_blank" class="fengstapp__whatsapp-open">
      <img src="https://vasco-gs.s3.amazonaws.com/prod/assets/images/bot%C3%A3o-wpp-secretaria.png" alt="Atendimento">
    </a>
  </div>

</div>

<div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()">
  <div class="popup-modal" (click)="$event.stopPropagation()">
    <button type="button" class="popup-close" aria-label="Fechar" (click)="closePopup()">&times;</button>
    <a [href]="popupLinkUrl" target="_blank" (click)="closePopup()">
      <img class="popup-image" [src]="popupImageUrl" alt="" />
    </a>
  </div>
</div>